/** Optional navigator lead endpoint. Empty string disables submission. Reuse /api/contact to send through the existing Resend contact route. Never put API keys here. */
export const NAVIGATOR_LEAD_ENDPOINT = '/api/contact'

export const NAVIGATOR_LEAD_SOURCE = 'uae-sustainability-regulation-navigator'
